import React, { useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import cn from "classnames";
import styles from "./faq.module.scss";
import { createTheme, ThemeProvider } from "@mui/material/styles";

export default function FaqPage() {
  const customTheme = createTheme({
    components: {
      MuiAccordion: {
        styleOverrides: {
          root: {
            "&.Mui-expanded": {
              margin: "0px !important", 
            },
          },
        },
      },
      MuiAccordionDetails: {
        styleOverrides: {
          root: {
            padding: "0px 16px 16px !important", 
          },
        },
      },
    },
  });
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className={cn(styles.MainContainer)}>
      <h1>FAQs</h1>
     <div className={cn(styles.AccordionContainer)}>
     <ThemeProvider theme={customTheme}>
        <Accordion
          expanded={expanded === "panel1"}
          onChange={handleChange("panel1")}
          sx={{
            margin: "0",
            boxShadow: "none",
            borderBottom: "1px solid #E0E0E0",
          }}
        >
          <AccordionSummary
            expandIcon={expanded === "panel1" ? <RemoveIcon className={cn(styles.Minus_icon)} /> : <AddIcon className={cn(styles.Add_icon)}/>}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography className={cn(styles.SummaryText)}>
              Why SwapUp ?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className={cn(styles.DetailText)}>
              SwapUp makes battery swapping process easy and faster for drivers,
              making it a hassle free experience for the user and an enabler for
              a better and green world.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel2"}
          onChange={handleChange("panel2")}
          sx={{
            margin: "0",
            boxShadow: "none",
            borderBottom: "1px solid #E0E0E0",
          }}
        >
          <AccordionSummary
            expandIcon={expanded === "panel2" ? <RemoveIcon className={cn(styles.Minus_icon)} /> : <AddIcon className={cn(styles.Add_icon)}/>}
            aria-controls="panel2bh-content"
            id="panel2bh-header"
          >
            <Typography className={cn(styles.SummaryText)}>What does SwapUp offer ?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className={cn(styles.DetailText)}>
              "SwapUp offers you access to multiple swapping stations from
              multiple operators which are compatible to the batteries in your
              vehicle. So if you have purchased your vehicle from company X;
              apart from using swapping station from X, you can also use
              swapping station from multiple other vendors that are compatible
              with the battery from X."
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel3"}
          onChange={handleChange("panel3")}
          sx={{
            margin: "0",
            boxShadow: "none",
            borderBottom: "1px solid #E0E0E0",
          }}
        >
          <AccordionSummary
            expandIcon={expanded === "panel3" ? <RemoveIcon className={cn(styles.Minus_icon)} /> : <AddIcon className={cn(styles.Add_icon)}/>}
            aria-controls="panel3bh-content"
            id="panel3bh-header"
          >
            <Typography className={cn(styles.SummaryText)}>Who can use SwapUp ?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className={cn(styles.DetailText)}>
              SwapUp can be used by drivers from all enterprises who have
              partnered with Jio for this service
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel4"}
          onChange={handleChange("panel4")}
          sx={{
            margin: "0",
            boxShadow: "none",
            borderBottom: "1px solid #E0E0E0",
          }}
        >
          <AccordionSummary
            expandIcon={expanded === "panel4" ? <RemoveIcon className={cn(styles.Minus_icon)} /> : <AddIcon className={cn(styles.Add_icon)}/>}
            aria-controls="panel4bh-content"
            id="panel4bh-header"
          >
            <Typography className={cn(styles.SummaryText)}>How do I assign a vehicle ?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className={cn(styles.DetailText)}>
              You can assign vehicle by clicking on "Unlock Vehicle" button and
              scanning the QR code on the vehicle. You can also manually enter
              the QR code number by clicking on "Manually enter QR code" link.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel5"}
          onChange={handleChange("panel5")}
          sx={{
            margin: "0",
            boxShadow: "none",
            borderBottom: "1px solid #E0E0E0",
          }}
        >
          <AccordionSummary
            expandIcon={expanded === "panel5" ? <RemoveIcon className={cn(styles.Minus_icon)} /> : <AddIcon className={cn(styles.Add_icon)}/>}
            aria-controls="panel5bh-content"
            id="panel5bh-header"
          >
            <Typography className={cn(styles.SummaryText)}>How to unassign the vehicle ?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className={cn(styles.DetailText)}>
              You can unassign your vehicle by clicking on "Remove vehicle"
              button and then on "Yes I am done!" button.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel6"}
          onChange={handleChange("panel6")}
          sx={{
            margin: "0",
            boxShadow: "none",
            borderBottom: "1px solid #E0E0E0",
          }}
        >
          <AccordionSummary
            expandIcon={expanded === "panel6" ? <RemoveIcon className={cn(styles.Minus_icon)} /> : <AddIcon className={cn(styles.Add_icon)}/>}
            aria-controls="panel6bh-content"
            id="panel6bh-header"
          >
            <Typography className={cn(styles.SummaryText)}>
              I am getting an error message "Invalid QR Code" ?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className={cn(styles.DetailText)}>
              Invalid QR code means the vehicle does not belong to your
              enterprise. In other words you and the vehicle do not belong to
              the same enterprise
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel7"}
          onChange={handleChange("panel7")}
          sx={{
            margin: "0",
            boxShadow: "none",
            borderBottom: "1px solid #E0E0E0",
          }}
        >
          <AccordionSummary
            expandIcon={expanded === "panel7" ? <RemoveIcon className={cn(styles.Minus_icon)} /> : <AddIcon className={cn(styles.Add_icon)}/>}
            aria-controls="panel7bh-content"
            id="panel7bh-header"
          >
            <Typography className={cn(styles.SummaryText)}>
              I am getting an error message "Vehicle Not Available" ?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className={cn(styles.DetailText)}>
              Vehicle Not Available means the vehicle is already assigned to
              another driver. Please choose another vehicle.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel8"}
          onChange={handleChange("panel8")}
          sx={{
            margin: "0",
            boxShadow: "none",
            borderBottom: "1px solid #E0E0E0",
          }}
        >
          <AccordionSummary
            expandIcon={expanded === "panel8" ? <RemoveIcon className={cn(styles.Minus_icon)} /> : <AddIcon className={cn(styles.Add_icon)}/>}
            aria-controls="panel8bh-content"
            id="panel8bh-header"
          >
            <Typography className={cn(styles.SummaryText)}>What I should ensure before I add a vehicle ?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className={cn(styles.DetailText)}>
              You should ensure the vehicle belongs to the same enterprise as
              yours and you are at the location of the vehicle.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel9"}
          onChange={handleChange("panel9")}
          sx={{
            margin: "0",
            boxShadow: "none",
            borderBottom: "1px solid #E0E0E0",
          }}
        >
          <AccordionSummary
            expandIcon={expanded === "panel9" ? <RemoveIcon className={cn(styles.Minus_icon)} /> : <AddIcon className={cn(styles.Add_icon)}/>}
            aria-controls="panel9bh-content"
            id="panel9bh-header"
          >
            <Typography className={cn(styles.SummaryText)}>How can I know when to swap battery ?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className={cn(styles.DetailText)}>
              You will receive a notification on the app when the battery charge
              reach 25% and below. Ideally, you should swap the battery when the
              battery charge is between 20% to 30%.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel10"}
          onChange={handleChange("panel10")}
          sx={{
            margin: "0",
            boxShadow: "none",
            borderBottom: "1px solid #E0E0E0",
          }}
        >
          <AccordionSummary
            expandIcon={expanded === "panel10" ? <RemoveIcon className={cn(styles.Minus_icon)} /> : <AddIcon className={cn(styles.Add_icon)}/>}
            aria-controls="panel10bh-content"
            id="panel10bh-header"
          >
            <Typography className={cn(styles.SummaryText)}>How can I locate a swapping station nearby ?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className={cn(styles.DetailText)}>
              You can find nearby swap station by clicking on the map button. It
              will show you all available/ compatible battery swap stations in
              the area along with distance from your location, no. of available
              batteries and the direction to the nearest one.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel11"}
          onChange={handleChange("panel11")}
          sx={{
            margin: "0",
            boxShadow: "none",
            borderBottom: "1px solid #E0E0E0",
          }}
        >
          <AccordionSummary
            expandIcon={expanded === "panel11" ? <RemoveIcon className={cn(styles.Minus_icon)} /> : <AddIcon className={cn(styles.Add_icon)}/>}
            aria-controls="panel11bh-content"
            id="panel11bh-header"
          >
            <Typography className={cn(styles.SummaryText)}>
              How do I get the direction to choosen swapping station ?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className={cn(styles.DetailText)}>
              You can get the direction on google map by clicking on the
              "direction" button on your choosen swap station
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel12"}
          onChange={handleChange("panel12")}
          sx={{
            margin: "0",
            boxShadow: "none",
            borderBottom: "1px solid #E0E0E0",
          }}
        >
          <AccordionSummary
            expandIcon={expanded === "panel12" ? <RemoveIcon className={cn(styles.Minus_icon)} /> : <AddIcon className={cn(styles.Add_icon)}/>}
            aria-controls="panel12bh-content"
            id="panel12bh-header"
          >
            <Typography className={cn(styles.SummaryText)}>How to reserve a battery ?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography >
              You can reserve a battery by clicking on the "reserve battery"
              button on your choosen swap station
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel813"}
          onChange={handleChange("panel813")}
          sx={{
            margin: "0",
            boxShadow: "none",
            borderBottom: "1px solid #E0E0E0",
          }}
        >
          <AccordionSummary
            expandIcon={expanded === "panel813" ? <RemoveIcon className={cn(styles.Minus_icon)} /> : <AddIcon className={cn(styles.Add_icon)}/>}
            aria-controls="panel13bh-content"
            id="panel13bh-header"
          >
            <Typography className={cn(styles.SummaryText)}>For how long I can reserve a battery ?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className={cn(styles.DetailText)}>
              Once you have reserved a battery, it gets blocked for use by any
              other user for 30 mins at your choosen swap station
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel14"}
          onChange={handleChange("panel14")}
          sx={{
            margin: "0",
            boxShadow: "none",
            borderBottom: "1px solid #E0E0E0",
          }}
        >
          <AccordionSummary
            expandIcon={expanded === "panel14" ? <RemoveIcon className={cn(styles.Minus_icon)} /> : <AddIcon className={cn(styles.Add_icon)}/>}
            aria-controls="panel14bh-content"
            id="panel14bh-header"
          >
            <Typography className={cn(styles.SummaryText)}>How can I cancel my reservation ?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className={cn(styles.DetailText)}>
              For cancelling your reservation, go to My reservation page and
              click on cancel button.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel15"}
          onChange={handleChange("panel15")}
          sx={{
            margin: "0",
            boxShadow: "none",
            borderBottom: "1px solid #E0E0E0",
          }}
        >
          <AccordionSummary
            expandIcon={expanded === "panel15" ? <RemoveIcon className={cn(styles.Minus_icon)} /> : <AddIcon className={cn(styles.Add_icon)}/>}
            aria-controls="panel15bh-content"
            id="panel15bh-header"
          >
            <Typography className={cn(styles.SummaryText)}>What happens if I do not reserve a battery ?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className={cn(styles.DetailText)}>
              If you do not cancel your reservation, the battery gets unblocked
              automatically after 30 mins from the time you had reserved it.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel16"}
          onChange={handleChange("panel16")}
          sx={{
            margin: "0",
            boxShadow: "none",
            borderBottom: "1px solid #E0E0E0",
          }}
        >
          <AccordionSummary
            expandIcon={expanded === "panel16" ? <RemoveIcon className={cn(styles.Minus_icon)} /> : <AddIcon className={cn(styles.Add_icon)}/>}
            aria-controls="panel16bh-content"
            id="panel16bh-header"
          >
            <Typography className={cn(styles.SummaryText)}>
              How can I know if battery available in the swap point is
              campatible with my vehicle ?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className={cn(styles.DetailText)}>
              The map view shows only those swap station with which your battey
              is compatible.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel17"}
          onChange={handleChange("panel17")}
          sx={{
            margin: "0",
            boxShadow: "none",
            borderBottom: "1px solid #E0E0E0",
          }}
        >
          <AccordionSummary
            expandIcon={expanded === "panel17" ? <RemoveIcon className={cn(styles.Minus_icon)} /> : <AddIcon className={cn(styles.Add_icon)}/>}
            aria-controls="panel17bh-content"
            id="panel17bh-header"
          >
            <Typography className={cn(styles.SummaryText)}>
              How can I swap battery once I am at the swap point ?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className={cn(styles.DetailText)}>
              Once you reach the swap station location, open the mobile app,
              scan the QR code on the swap point, click on the "initiate swap"
              button. Once a slot door will opens, place your battery in it and
              wait for few seconds for another slot door to open. Remove the
              fully charged battery and place it in your vehicle.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel18"}
          onChange={handleChange("panel18")}
          sx={{
            margin: "0",
            boxShadow: "none",
            borderBottom: "1px solid #E0E0E0",
          }}
        >
          <AccordionSummary
            expandIcon={expanded === "panel18" ? <RemoveIcon className={cn(styles.Minus_icon)} /> : <AddIcon className={cn(styles.Add_icon)}/>}
            aria-controls="panel18bh-content"
            id="panel18bh-header"
          >
            <Typography className={cn(styles.SummaryText)}>What is battery swap tarriff for the day ?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className={cn(styles.DetailText)}>
              Tariff for swap will be different at different swap stations and
              usually depends on the electricity tariff for a particular time of
              the day. The tariff is displayed on the swap station view when you
              click on a swap station icon on the map
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel19"}
          onChange={handleChange("panel19")}
          sx={{
            margin: "0",
            boxShadow: "none",
            borderBottom: "1px solid #E0E0E0",
          }}
        >
          <AccordionSummary
            expandIcon={expanded === "panel19" ? <RemoveIcon className={cn(styles.Minus_icon)} /> : <AddIcon className={cn(styles.Add_icon)}/>}
            aria-controls="panel19bh-content"
            id="panel19bh-header"
          >
            <Typography className={cn(styles.SummaryText)}>How much a battery swap cost ?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className={cn(styles.DetailText)}>
              The swap cost is calculated based on the difference of electrical
              energy between swapped In and swapped Out batteries.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel20"}
          onChange={handleChange("panel20")}
          sx={{
            margin: "0",
            boxShadow: "none",
            borderBottom: "1px solid #E0E0E0",
          }}
        >
          <AccordionSummary
            expandIcon={expanded === "panel20" ? <RemoveIcon className={cn(styles.Minus_icon)} /> : <AddIcon className={cn(styles.Add_icon)}/>}
            aria-controls="panel20bh-content"
            id="panel20bh-header"
          >
            <Typography className={cn(styles.SummaryText)}>How can I pay for the battery swapped ?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className={cn(styles.DetailText)}>
              The price for battery swap will be deducted from your SwapUp
              wallet balance. Hence, It is advisable to ensure minimum balance
              for better user experience.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel21"}
          onChange={handleChange("panel21")}
          sx={{
            margin: "0",
            boxShadow: "none",
            borderBottom: "1px solid #E0E0E0",
          }}
        >
          <AccordionSummary
            expandIcon={expanded === "panel21" ? <RemoveIcon className={cn(styles.Minus_icon)} /> : <AddIcon className={cn(styles.Add_icon)}/>}
            aria-controls="panel21bh-content"
            id="panel21bh-header"
          >
            <Typography className={cn(styles.SummaryText)}>
              What is the minimum wallet balance that I must ensure for faster
              swapping ?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className={cn(styles.DetailText)}>
              It is advisable to ensure minimum balance of INR 75 for better
              user experience.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel22"}
          onChange={handleChange("panel22")}
          sx={{
            margin: "0",
            boxShadow: "none",
            borderBottom: "1px solid #E0E0E0",
          }}
        >
          <AccordionSummary
            expandIcon={expanded === "panel22" ? <RemoveIcon className={cn(styles.Minus_icon)} /> : <AddIcon className={cn(styles.Add_icon)}/>}
            aria-controls="panel22bh-content"
            id="panel22bh-header"
          >
            <Typography className={cn(styles.SummaryText)}>
              What happens if I do not have minimum wallet balance ?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className={cn(styles.DetailText)}>
              You must ensure minimum balance to complete a swap transaction. It
              is a must before you take out a fully charged battery from the
              swap station.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel23"}
          onChange={handleChange("panel23")}
          sx={{
            margin: "0",
            boxShadow: "none",
            borderBottom: "1px solid #E0E0E0",
          }}
        >
          <AccordionSummary
            expandIcon={expanded === "panel23" ? <RemoveIcon className={cn(styles.Minus_icon)} /> : <AddIcon className={cn(styles.Add_icon)}/>}
            aria-controls="panel23bh-content"
            id="panel23bh-header"
          >
            <Typography className={cn(styles.SummaryText)}>My wallet balance shows zero balance ?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className={cn(styles.DetailText)}>
              If your wallet balance is zero, check your transaction history. If
              there are any discrepancy, please reach out to us.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel24"}
          onChange={handleChange("panel24")}
          sx={{
            margin: "0",
            boxShadow: "none",
            borderBottom: "1px solid #E0E0E0",
          }}
        >
          <AccordionSummary
            expandIcon={expanded === "panel24" ? <RemoveIcon className={cn(styles.Minus_icon)} /> : <AddIcon className={cn(styles.Add_icon)}/>}
            aria-controls="panel24bh-content"
            id="panel24bh-header"
          >
            <Typography className={cn(styles.SummaryText)}>How to add funds to my wallet ?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className={cn(styles.DetailText)}>
              You can add funds to your wallet via UPI, Debit/ Credit cards,
              online banking, etc.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel25"}
          onChange={handleChange("panel25")}
          sx={{
            margin: "0",
            boxShadow: "none",
            borderBottom: "1px solid #E0E0E0",
          }}
        >
          <AccordionSummary
            expandIcon={expanded === "panel25" ? <RemoveIcon className={cn(styles.Minus_icon)} /> : <AddIcon className={cn(styles.Add_icon)}/>}
            aria-controls="panel25bh-content"
            id="panel25bh-header"
          >
            <Typography className={cn(styles.SummaryText)}>
              Money debited from bank account but balance not reflecting in my
              wallet ?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className={cn(styles.DetailText)}>
              If money is debited from your bank account but not reflecting in
              your wallet balance, the amount will be credited back to your bank
              account within 7 business days.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel26"}
          onChange={handleChange("panel26")}
          sx={{
            margin: "0",
            boxShadow: "none",
            borderBottom: "1px solid #E0E0E0",
          }}
        >
          <AccordionSummary
            expandIcon={expanded === "panel26" ? <RemoveIcon className={cn(styles.Minus_icon)} /> : <AddIcon className={cn(styles.Add_icon)}/>}
            aria-controls="panel26bh-content"
            id="panel26bh-header"
          >
            <Typography className={cn(styles.SummaryText)}>Unable to add funds to wallet ?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className={cn(styles.DetailText)}>
              If you are not able to add funds to your wallet, please check the
              network level in your area. If that does not solve the issue,
              please close the application and restart again.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel27"}
          onChange={handleChange("panel27")}
          sx={{
            margin: "0",
            boxShadow: "none",
            borderBottom: "1px solid #E0E0E0",
          }}
        >
          <AccordionSummary
            expandIcon={expanded === "panel27" ? <RemoveIcon className={cn(styles.Minus_icon)} /> : <AddIcon className={cn(styles.Add_icon)}/>}
            aria-controls="panel27bh-content"
            id="panel27bh-header"
          >
            <Typography className={cn(styles.SummaryText)}>Where can I get my invoice for battery swap ?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className={cn(styles.DetailText)}>
              If can view/ download/ share your invoice from the swap
              transaction history in the my account section
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel28"}
          onChange={handleChange("panel28")}
          sx={{
            margin: "0",
            boxShadow: "none",
            borderBottom: "1px solid #E0E0E0",
          }}
        >
          <AccordionSummary
            expandIcon={expanded === "panel28" ? <RemoveIcon className={cn(styles.Minus_icon)} /> : <AddIcon className={cn(styles.Add_icon)}/>}
            aria-controls="panel28bh-content"
            id="panel28bh-header"
          >
            <Typography className={cn(styles.SummaryText)}>
              Where can I find my wallet transaction details ?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className={cn(styles.DetailText)}>
              You can find your wallet transaction history in the wallet page.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </ThemeProvider>
     </div>
    </div>
  );
}
